const UNITS = [
  'B',
  'k',
  'M',
  'G',
  'T',
  'P',
  'E',
  'Z',
  'Y',
];

export type LocalType = boolean | string;

export interface PrettyBytes {
  /** 是否有正负号 */
  signed?: boolean;
  /**
   * 地区
   * 参考： https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/
   * Global_Objects/Number/toLocaleString#Checking_for_support_for_locales_and_options_arguments
   */
  locale?: LocalType;
}

/*
https://github.com/sindresorhus/pretty-bytes
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/
const toLocaleString = (num: number, locale?: LocalType) => {
  let result: number | string = num;
  if (typeof locale === 'string') {
    result = num.toLocaleString(locale);
  } else if (locale === true) {
    result = num.toLocaleString();
  }

  return result;
};

const prettyBytes = (num: number, options?: PrettyBytes) => {
  if (!Number.isFinite(num)) {
    console.error(`Expected a finite number, got ${typeof num}: ${num}`);
    return;
  }

  options = Object.assign({}, options);

  if (options.signed && num === 0) {
    return ' 0 B';
  }

  const isNegative = num < 0;
  const prefix = isNegative ? '-' : (options.signed ? '+' : '');

  if (isNegative) {
    num = -num;
  }

  if (num < 1) {
    const numberString = toLocaleString(num, options.locale);
    return prefix + numberString + ' B';
  }

  const exponent = Math.min(Math.floor(Math.log10(num) / 3), UNITS.length - 1);
  num = Number((num / Math.pow(1024, exponent)).toPrecision(3));
  const numberString = toLocaleString(num, options.locale);

  const unit = UNITS[exponent];

  return prefix + numberString + ' ' + unit;
};

export default prettyBytes;
